import { ISettingsStore } from './settings-store';
import { Observable } from 'rxjs';

export class PostgresqlSettingsStore implements ISettingsStore {
  getSetting$(key: string): Observable<string | null> {
    throw new Error('Not implemented');
  }
  setSetting$(settingKey: string, value: string): Observable<boolean> {
    throw new Error('Not implemented');
  }
}
